<template>
    <div>
    </div>
</template>

<script>
export default {
    data: () => ({}),
    
    created() {},

    methods: {}
}
</script>

<style lang="scss" scoped>
</style>
